export default __webpack_public_path__ + "static/media/Discharge.94b00d3a.svg";